import { ProductState } from "../store/chart";

export type GaEvent = {
  event: string;
  action: string;
  Label: string;
  ecommerce?: any;
};

export type GaDataLayer = GaEvent[];

const onChartLoad = (_dataLayer: GaDataLayer = []) => {};

const onTableVisible = (
  dataLayer: GaDataLayer = [],
  products: ProductState[] = [],
) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Scroll to Compare Roomba",
    Label: products.map((p) => p.name).join("|"),
    ecommerce: {
      impressions: products.map((product, index) => ({
        name: product.name || "",
        id: product.sku,
        list: "Comparison Chart",
        position: index + 1,
      })),
    },
  });
};

const onShowOnlyDifferencesToggle = (
  dataLayer: GaDataLayer = [],
  toggleStatus = false,
) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Roomba | Show Only Differences",
    Label: toggleStatus ? "Toggled on" : "Toggled off",
  });
};

const onProductSelect = (
  dataLayer: GaDataLayer = [],
  product: ProductState,
) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Roomba Selection",
    Label: product.name,
  });
};

const onProductUnselect = (
  dataLayer: GaDataLayer = [],
  product: ProductState,
) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Roomba Unselection",
    Label: product.name,
  });
};

const onShopClick = (dataLayer: GaDataLayer = [], product: ProductState) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Click on Shop",
    Label: product.name,
    ecommerce: {
      click: {
        actionField: { list: "Comparison Chart" },
        products: [
          {
            name: product.name,
            id: product.sku,
          },
        ],
      },
    },
  });
};

const onShopSelectClick = (
  dataLayer: GaDataLayer = [],
  product: ProductState,
) => {
  dataLayer.push({
    event: "comparisonChart",
    action: "Click on Shop",
    Label: product.name,
    ecommerce: {
      click: {
        actionField: { list: "Comparison Chart" },
        products: [
          {
            name: product.name,
            id: product.sku,
          },
        ],
      },
    },
  });
};

const ga = {
  onChartLoad,
  onTableVisible,
  onShowOnlyDifferencesToggle,
  onProductSelect,
  onProductUnselect,
  onShopClick,
  onShopSelectClick,
};

export default ga;
